











































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import DocumentModel from "@/models/document.model";
import BTableColumn from "@/models/base/BTableColumn.model";
import GenericBTable from "@/core/Generics/GenericBTable";
import { BTableColumnType } from "@/enums/BTableColumnType";
import fileService from "@/services/file.service";

@Component
export default class DocumentTableViewer extends GenericBTable<DocumentModel> {
  @Prop() readonly selected!: DocumentModel;
  @Prop() readonly showTitle!: boolean;
  @Prop() readonly multiple!: boolean;
  @Prop() readonly selectable!: boolean;
  @Prop() readonly title!: string;
  @Prop() readonly aggregable!: string;

  @Prop() readonly whereParams!: string;
  @Prop() readonly refName!: string;
  @Prop() readonly refKey!: string;
  @Prop() readonly refValue!: string;
  @Prop() readonly contentTypeId!: number;

  archivo: File | null = null;
  document: DocumentModel | undefined = this.selected || undefined;
  uploading = false;
  errorUpload = false;
  successUpload = false;

  get isMobile() {
    return this.$store.state.isMobile;
  }
  created() {
    this.setupTable();
    this.formatColumns();
  }
  setupTable() {
    this.tableConfig.controller = "documents";
    this.tableConfig.whereParams = this.queries;
    this.tableConfig.activeActions = false;
    this.tableConfig.enableDefaultColumns = false;
    this.tableConfig.selectable = this.selectable;
    this.tableConfig.checkable = this.multiple;
    this.tableConfig.style.narrowed = true;
    this.tableConfig.pagination.perPage = 5;
    this.tableConfig.emptyText = "No hay documents asociados.";
    if (this.tableConfig.checkable)
      this.tableConfig.checking.check = this.onCheck;
    if (this.tableConfig.selectable)
      this.tableConfig.selection.change = this.onSelect;
  }
  formatColumns() {
    let preview = new BTableColumn("preview", String(" "), false);
    preview.customTemplate = true;
    preview.width = "60";
    let nombre = new BTableColumn("originalName", "Document");
    let fecha = new BTableColumn("createdDate", "Date");
    fecha.type = BTableColumnType.DateTime;
    this.tableConfig.insertColumns(preview, nombre, fecha);
  }
  public onCheck(list: DocumentModel[], row: DocumentModel) {
    this.$emit("current-check", row);
    this.$emit("check", list);
  }
  public onSelect(row: DocumentModel, oldRow: DocumentModel) {
    this.$emit("select", row);
  }
  async verDocument(id: number) {
    await fileService.download(id);
  }

  public add() {}
  quitarArchivo() {
    this.archivo = null;
    this.document = undefined;
    this.tableConfig.selection.selected = undefined;
    let selected = this.map<DocumentModel>(this.selected);
    this.$emit("remove", selected);
  }
  selectFile(file: File) {
    this.errorUpload = false;
    this.successUpload = false;
    this.archivo = file;
    this.subirArchivo();
    this.$emit("selectFile", this.archivo);
  }
  async subirArchivo() {
    try {
      this.uploading = true;
      let doc = await fileService.upload(this.archivo as File);
      this.document = new DocumentModel(
        doc.fileName,
        doc.contentType,
        doc.originalName
      );
      this.document.refEntityName = this.refName;
      this.document.refEntityKey = this.refKey;
      this.document.refEntityValue = this.refValue;
      this.document.contentTypeId = this.contentTypeId;
      this.successUpload = true;
      this.tableConfig.selection.selected = undefined;
      this.$emit("select", this.document);
    } catch (error) {
      this.errorUpload = true;
    } finally {
      this.uploading = false;
    }
  }
  get queries() {
    let where = String();
    let queries = [];
    queries.push(`ContentTypeId eq ${this.contentTypeId}`);
    if (this.refName) {
      queries.push(`RefEntityName eq '${this.refName}'`);
      queries.push(`RefEntityKey eq '${this.refKey}'`);
      queries.push(`RefEntityValue eq '${this.refValue}'`);
    }

    where = queries.join(" and ");
    if (this.whereParams) where += this.whereParams;
    return where;
  }

  @Watch("contentTypeId")
  onTipoDocumentChange(value: number | undefined) {
    this.tableConfig.whereParams = this.queries;
    if (this.tableConfig.reload) this.tableConfig.reload();
  }

  @Watch("refValue")
  onRefValueChanve(value: string | undefined) {
    this.tableConfig.whereParams = this.queries;
    if (this.tableConfig.reload) this.tableConfig.reload();
  }
}
